import { LitEntity, SirenActionMixin, html, css } from '../utility/lit-entity';
import { IndexMixin } from '../utility/index-mixin';
import { sharedStyles } from '../styles/shared-styles';
import { renderListItem } from './parts/device-render-list-item';
import './device-list';
import '../organizations/parts/organization-ancestors-bread-crumbs';
import '../organizations/parts/organization-dropdown';
import './parts/add-device-button';
import './parts/device-list-by-flag-view';
import './parts/find-device-modal';

import './props/devices-total-count-by-flag';
import '../common/bn-tabs';
import '../common/bn-tab';
import '../common/bn-icon';

class DeviceDashboard extends IndexMixin(SirenActionMixin(LitEntity)) {
  constructor() {
    super();
    this.flags = {};
    this.flagNames = [];
  }

  static get properties() {
    return {
      organizationDevicesHref: { type: String, attribute: false },
      showFindDevice: { type: Boolean, attribute: false },
      flags: { type: Object, attribute: false },
      flagNames: { type: Array, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      :host {
        display: block;
        position: relative;
      }
      .title-container {
        margin: var(--root-margin) var(--root-margin) 0 var(--root-margin);
      }
      h1 {
        margin: 0;
      }
      .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        flex-shrink: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .right-actions {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        flex-wrap: wrap;
      }
      .right-actions > * {
        margin: .5em .5em .5em 0;
      }
      organization-ancestors-bread-crumbs {
        --last-crumb-overflow: visible;
      }
      bn-tabs {
        margin-bottom: 0;
      }
      .tab-inner {
        display: inline-flex;
        align-items: center;
        text-decoration: none;
      }
      devices-total-count-by-flag {
        border: 1px solid;
        border-radius: 100px;
        display: inline-block;
        text-align: center;
        font-size: 0.75em;
        font-weight: 900;
        line-height: 22px;
        width: 21px;
        height: 21px;
        margin-right: .5em;
        align-items: center;
        display: flex;
        justify-content: center;
      }
      .tab-title {
        text-transform: capitalize;
      }
      h3 {
        margin-left: .5em;
      }
    `];
  }

  render() {
    return html`
      <div class="title-container">
        <div class="title">
          <h1>Devices</h1>
          <span class="right-actions">
            <button
              class="button button--contained"
              @click="${() => this.showFindDevice = true}"
            >
              <bn-icon name="fal fa-search"></bn-icon> Find Device
            </button>
            <add-device-button .href="${this.organizationDevicesHref}" @update="${this._onOrganizationDevices}"></add-device-button>
          </span>
        </div>

        <organization-ancestors-bread-crumbs
          .href="${this.href}"
          linkPath="${window.location.pathname}"
          ancestorMinIndex="0"
        >
          <organization-dropdown dest="${window.location.pathname}" .href="${this.href}"></organization-dropdown>
        </organization-ancestors-bread-crumbs>
      </div>

      <find-device-modal
        .href="${this.organizationDevicesHref}"
        .hide="${!this.showFindDevice}"
        @success="${this._onFind}"
        @close="${() => this.showFindDevice = false}"
      ></find-device-modal>

      <bn-tabs>${this._renderTabs()}</bn-tabs>

      ${super.render()}
    `;
  }

  _renderTabs() {
    return html`
      ${this.flagNames.map((name) => html`
        <bn-tab href="/devices/list/${name}" ?active="${this.currentView === name}">
          <div class="tab-inner">
            <devices-total-count-by-flag
              .href="${this.organizationDevicesHref}"
              flagname="${name}"
              maxcount=999
            ></devices-total-count-by-flag>
            <span class="tab-title">${this.flags[name].title}</span>
          </div>
        </bn-tab>
      `)}
    `;
  }

  getViews() {
    return [
      ...this.flagNames.map((name, i) => ({
        name,
        default: i === 0,
        render: () => html`
          <device-list-by-flag-view
            flagname="${name}"
            .href="${this.organizationDevicesHref}"
            .renderItem=${(args) => renderListItem({ name, ...args })}
          ></device-list-by-flag-view>
        `,
      })),
    ];
  }

  _onOrganizationDevices(e) {
    const { entity } = e.detail;
    if (!entity) {
      return;
    }

    const action = entity.getActionByName('filter-by-flag');
    if (!action) {
      return;
    }

    const flagField = action.getFieldByName('flag');

    this.flagNames = [];
    this.flags = {};
    flagField.value.forEach((fieldVal) => {
      this.flagNames.push(fieldVal.value);
      this.flags[fieldVal.value] = fieldVal;
    });

    this.currentView = this.currentView || this.flagNames[0];
  }

  _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.organizationDevicesHref = this.getHref('https://api.binsentry.com/rel/v2/devices');
  }
}

window.customElements.define('device-dashboard', DeviceDashboard);
